export const expensesEn = {
  upload_expenses: "Upload expenses",
  upload_success: `Successfully uploaded`,
  download_expenses: "Download expense",
  expenses: "Expenses",
  expense_management: "Expense management",
  expense_upload_title: `Expense Upload`,
  instructions_description: `Drop the CSV here or click browse through your machine.`,
  upload_file: `Upload`,
  confirm_upload_message: `Are you sure you want to upload this CSV`,
  employee_required: `Employee is required`,
  csv_format_allowed: `CSV format is invalid`,
  csv_notvalid: "Invalid CSV",
  download_file: `Download file`,
  in_process: `In process`,
  processed: `Processed`,
  failed: `Failed`,
  file_name: `File name`,
  uploaded_on: `Uploaded on`,
  uploaded_by: `Uploaded by`,
  status: `Status`,
  actions: `Actions`,
  no: `No`,
  yes: "Yes",
  receipt_number: "Receipt number",
  expense_date: "Expense date",
  vendor: "Vendor",
  currency: "Currency",
  total_amount: "Total amount",
  total_tax: "Total tax",
  payment_status: "Payment status",
  created_by: "Created by",
  delete: "Delete",
  deleting: "Deleting",
  edit: "Edit",
  view_receipt_details: "View receipt details",
  paid: "Paid",
  partially_paid: "Partially paid",
  overdue: "Overdue",
  pending: "Pending",
  view: `View`,
  view_expense_details: `View expense details`,
  expense_items: `Expense items`,
  total_summary: `Total summary`,
  created_info: `Created info`,
  completed_on: `Completed on`,
  download_success: `Successfully download`,
  employee_notfound: `Employee not found`,
  category: `Category`,

  // expense category
  expense_category: `Expense category`,
  id: `ID`,
  category_name: `Category name`,
  add_category: `Add category`,
  add_expense_category: `Add expense category`,
  placeholder_category_name: `enter category name`,
  expense_category_exists: `Expense category already exists`,
  category_name_required: `Category name required`,
  category_name_min: `Category name must be at least 3 characters long`,
  category_name_max: `Category name must not exceed 50 characters`,
  category_name_only_alphabets: `Only alphabets and spaces are allowed`,
  category_created_success: `Category created successfully`,
  no_permission: `You dont't have permission for expense category`,
  edit_expense_category: "Edit Expense Category",
  category_updated_success: "Category updated successfully",
  successfully_deleted: "Successfully deleted",
  delete_failed: "Delete failed",
  delete_category_dialog: "Delete Category",
  expensecategoty_not_found: "Expense category not found",
  expense: `Expense`,
  upload_request: `Upload request`,
  category_setup: `Category setup`,
};
